import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { Box, Typography } from "@mui/material";

interface StatusSwitchProps extends SwitchProps {
  rtl?: boolean;
  status: "on" | "off" | "pending";
}

const IosSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== "rtl",
})<StatusSwitchProps>(({ theme, rtl, status }) => ({
  width: 57,
  height: 18,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 1,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(0px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#22C884",
        opacity: 1,
        border: 0,
      },
    },
    "&.Mui-disabled": {
      transform: "translateX(42px)",

      "& + .MuiSwitch-track": {
        backgroundColor: "#E5E7EB",
        opacity: 1,
      },
      "& .MuiSwitch-thumb": {
        backgroundColor: "#fff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 16,
    height: 16,
    backgroundColor: "#fff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    position: "relative",
    zIndex: 1,
  },
  "& .MuiSwitch-track": {
    borderRadius: 9,
    backgroundColor: "#E5E7EB",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 300,
    }),
    position: "relative",
    "&::before": {
      content: status === "on" ? '"نشط"' : '"معطل"',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      color: status === "on" ? "#fff" : "#8A8A8A",
      fontSize: "7px",
      fontWeight: 600,
      fontFamily: "inherit",
      pointerEvents: "none",
      zIndex: 0,
    },
  },
}));

export default function StatusSwitch({
  status,
  rtl,
  ...props
}: StatusSwitchProps) {
  if (status === "pending") {
    return (
      <Typography
        sx={{
          color: "#525866",
          fontSize: "17px",
          fontWeight: 600,
          textAlign: "center",
        }}>
        بانتظار التفعيل
      </Typography>
    );
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <IosSwitch
        rtl={rtl}
        status={status}
        checked={status === "on"}
        disabled={status === "off"}
        {...props}
      />
    </Box>
  );
}
